import type {
  Answers,
  ShadowGroup,
  UpdateAnswerPayload,
} from "../../../../types";
import { deriveShadowChildrenAnswers } from "../shared/deriveShadowChildrenAnswers";

type ApplyMultiselectUpdatesArgs = {
  shadowGroup: ShadowGroup;
  answers: Answers;
  value: UpdateAnswerPayload["value"];
};

export const applyMultiselectUpdates = ({
  shadowGroup,
  answers,
  value,
}: ApplyMultiselectUpdatesArgs): {
  answers: Answers;
} => {
  const selectedValues = Array.isArray(value) ? value : [];
  const nextAnswers = deriveShadowChildrenAnswers({
    shadowGroup,
    selectedValues,
    answers,
  });

  return { answers: nextAnswers };
};
